import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {LoadingSpinnerComponent} from "../../ui/loading-spinner-component";
import {CommonModule, NgForOf, NgIf, NgTemplateOutlet} from "@angular/common";
import {PlusMinusButtonComponent} from "../../buttons/plus-minus-button.component";
import {
  AbstractControl,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  Validators
} from "@angular/forms";
import {SmallActionButtonComponent} from "../../buttons/small-action-button.component";
import {ActionButtonComponent} from '../../buttons/action-button.component';
import {PageButtonComponent} from '../../buttons/page-button.component';
import {CircleButtonComponent} from '../../buttons/circle-button.component';
import {ThemeService} from '../../../services/theme-service';
import {ActivatedRoute, Router} from '@angular/router';
import {OrderService} from '../../../services/order.service';
import {MenuService} from '../../../services/menu.service';
import {ConfigService} from '../../../services/config.service';
import {AppStateService} from '../../../services/app-state.service';
import {firstValueFrom, mergeMap, Observable, of, Subscription} from 'rxjs';
import {AppState} from '../../../models/AppState';
import {
  Order,
  OrderItem,
  UserSpecificConfigLoyalty,
  UserSpecificConfigLoyaltyDiscountCode, UserSpecificConfigLoyaltyRewardTrigger,
  PrebookPartyGuest
} from '../../../models/Order';
import {ViewportService} from '../../../services/viewport-service';
import MoneyUtils, {MenuUtils, TimeUtils} from '../../../utils/Utils';
import {PlusMinusSMButtonComponent} from '../../buttons/plus-minus-sm-button.component';
import {SeparatorComponent} from '../../ui/separator.component';
import {LightIconButtonComponent} from '../../buttons/light-icon-button-component';
import {TipButtonComponent} from '../../buttons/tip-button.component';
import {AuthService} from '../../../services/auth.service';
import {PaymentSelectorComponent} from '../../ui/payment-selector.component';
import {tap} from 'rxjs/operators';
import {SnackbarService} from '../../../services/snackbar.service';
import {PaymentInputData, PaymentOutputData, PaymentService} from '../../../services/payment.service';
import {ModalService} from '../../../services/modal.service';
import {ExampleModalComponent} from '../../dialogs/example-dialog.component';
import {SelectCardDialogComponent} from '../../dialogs/select-card-dialog.component';
import {WebCodeModalComponent} from '../../dialogs/web-code-dialog.component';
import {RescanDialogComponent} from '../../dialogs/rescan-dialog.component';
import { EnterDiscountCodeDialogComponent } from '../../dialogs/enter-discount-code-dialog';
import { UrlHistoryService } from '../../../services/url.history.service';
import {BoxForCheckboxComponent} from '../../ui/box-for-checkbox.component';
import {PushItemContentComponent} from '../../ui/push-item-content.component';
import {MenuItem, MenuStructure, PickedPackage} from '../../../models/FSMenu';
import {TipSelectionComponent, TipChangeEvent} from '../../ui/tip-selection.component';
import {BorderIconButtonComponent} from '../../buttons/border-icon-button.component';
import {BottomSheetService} from '../../../services/bottom-sheet.service';
import moment from 'moment';
import {RadioLabelComponent} from '../../ui/radio-label.component';
import { RoomCodeModalComponent } from '../../dialogs/room-code-dialog.component';
import {SignInComponent} from '../../sign-in/sign-in.component';
import {VenueConfig} from '../../../models/FSConfig';
import { BamboraTokenizedAuth } from '../../../models/PaymentModels';
import {SelectTimeDialogComponent} from '../../dialogs/select-time-dialog.component';
import {LinkButtonComponent} from '../../buttons/link-button.component';
import {InlineDonationsComponent} from "../../common/inline-donations.component";
import {TranslateService} from '../../../services/translate.service';
import { LoyaltyInfoComponent } from '../../ui/loyalty-info.component';
import {TipService} from '../../../services/tip.service';
import {ActiveTipConfig} from '../../../models/active-tip-config-model';
import {PrebookBannerComponent} from '../../ui/prebook-banner.component';

@Component({
  selector: 'app-cart',
  standalone: true,
  imports: [
    LoadingSpinnerComponent,
    NgForOf,
    NgIf,
    PlusMinusButtonComponent,
    ReactiveFormsModule,
    SmallActionButtonComponent,
    ActionButtonComponent,
    PageButtonComponent,
    CircleButtonComponent,
    PlusMinusSMButtonComponent,
    SeparatorComponent,
    ActionButtonComponent,
    LightIconButtonComponent,
    TipButtonComponent,
    PaymentSelectorComponent,
    BoxForCheckboxComponent,
    PushItemContentComponent,
    FormsModule,
    TipSelectionComponent,
    BorderIconButtonComponent,
    RadioLabelComponent,
    NgTemplateOutlet,
    SignInComponent,
    LinkButtonComponent,
    InlineDonationsComponent,
    CommonModule,
    LoyaltyInfoComponent,
    PrebookBannerComponent
],
  templateUrl: './cart.component.html',
  styleUrl: './cart.component.css'
})
export class CartComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('contentDiv') contentDiv!: ElementRef;
  isWorking = false;
  itemCount = 0;
  actionTitle = "Betala";
  title = "Din beställning";
  editableItems?: OrderItem[];
  fixedItems?: OrderItem[];
  includedChildrenByRid: Record<string, OrderItem[]> = {};
  // Under a package with choices or part attributes: what its parts are
  packageDetailsByRid: Record<string, string[] | null> = {};
  // Packages whose picks or part attributes the guest can change (with "Ändra")
  packageChangeableByRid: Record<string, boolean> = {};
  payableItems?: any[];
  isLoading = false;
  showSpinner = false;
  private sub?: Subscription;
  appState?: AppState;
  order?: Order;
  tipAmount? = 0;
  tipButtonId = "0";
  tipConfig?: ActiveTipConfig;
  tipAmountFormatted: string = "0 kr";
  isKiosk: boolean = false;
  inlineRecommendations: MenuItem[] | null = null;
  inlineDonations?: any[];
  selectedItems: Record<string, any> = {};
  attrValues: Record<string, any> = {};
  // Suggested packages picked in the item view, by item id
  picked: Record<string, PickedPackage> = {};
  itemRefs?: any[];
  isDualPage: boolean|undefined = undefined;
  showTip: boolean = false; // Tip active => show on payment page
  showMainContent: boolean = false;
  showOrderPayTip: boolean = false; // true if we are on the payment page
  roomHint = "rum";
  pickupTime = "now";
  pickupLocation?: string;
  fulfillmentMode?: string;
  pickupDateText?: string;
  namespaceName?: string;
  whenReadable?: string;
  customCollects?: any[];
  showLogin?: boolean;
  config?: VenueConfig;
  show_discount = false;
  loyaltyInfo?: UserSpecificConfigLoyalty;
  venueOpen = false;

  constructor(private themeService: ThemeService, private router: Router,
              private orderService: OrderService, private menuService: MenuService,
              private configService: ConfigService, private route: ActivatedRoute,
              private appStateService: AppStateService, private viewportService: ViewportService,
              private auth: AuthService, private menu: MenuService,
              private snackbarService: SnackbarService, private paymentService: PaymentService,
              private modalService:ModalService, private identityService: UrlHistoryService,
              private bottomSheetService: BottomSheetService, private translate: TranslateService,
              private tipService: TipService) {}

  ngOnInit(): void {
    this.beginObserving();
    this.isKiosk = this.auth.isKioskMode();
    this.title = this.getString("Din beställning");
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  ngAfterViewInit() {
    const topOffset = this.contentDiv.nativeElement.getBoundingClientRect().top;
    this.contentDiv.nativeElement.style.setProperty('--top-offset', `${topOffset}px`);
    setTimeout(() => {
      this.contentDiv.nativeElement.scrollTo({
        top: 0,
        behavior: 'instant'
      });
    });
  }

  private beginObserving() {
    this.sub = this.appStateService.observeAppState().subscribe(appState => {
      this.appState = appState;
      const orderHasChanged = this.order !== appState.order;
      this.order = appState.order;
      // A prebooking sent to the venue is a booking now: everyone of the party sees it in the booking view, as the
      // booker does after sending, instead of an empty cart of their own
      const bookedRef = this.order?.prebook?.booked?.booking_ref;
      if (bookedRef) {
        this.router.navigate([this.appStateService.venueId, 'booking', bookedRef], { replaceUrl: true });
        return;
      }
      this.itemCount = MenuUtils.getItemCount(this.order.items);
      this.updateTitle();

      // this.venueId = appState.venueId;
      this.config = appState.cfg;
      // this.isLoading = false;
      // this.isMessenger = this.messengerService.isMessenger(this.order);
      const iao = this.order.user_cfg?.is_anon_orderable;
      this.showLogin = this.order.user_cfg.is_anon && !iao && !this.auth.kioskMode;
      // this.showAnonOrderPanel = this.order.user_cfg.is_anon && iao && !this.auth.kioskMode;
      // this.roomHint = this.configService.getText("room_hint");
      this.setupItemsForDisplay();
      // this.setupPayableItems();

      this.venueOpen = MenuUtils.isDeliverTypeOpen(appState.order.user_cfg.dt, appState.cfg);

      const loyInfo = appState?.order?.user_cfg?.loyalty_card;
      if (loyInfo) {
        //points = appState.order?.user_cfg?.loyalty?.points;
        //"Detta köp ger dig 210p."
        this.loyaltyInfo = appState.order?.user_cfg?.loyalty_card;
        this.show_discount = false;
      } else {
        this.show_discount = appState?.cfg?.show_discount;
        this.loyaltyInfo = undefined;
      }

      this.fulfillmentMode = this.order.fulfillment;
      this.pickupTime = this.order.pickup_time ? "later" : "now";
      if (this.order.pickup_date) {
        const pd = moment(this.order.pickup_date, "YYYY-MM-DD HH:mm:ss");
        this.pickupDateText = TimeUtils.getRelativeDayStringTimeDate(pd);
      }

      if (orderHasChanged) {
        const menuStruct = this.menu.getMenuStructure();
        if (menuStruct && this.order) {
          this.prepareInlinePush(menuStruct!);
          this.extractPostactionInfo(menuStruct!);
        }
      }
      //
      // if (this.order.namespace) {
      //   this.namespaceName = this.config.dt?.takeaway?.slotting?.namespaces?.find(ns => ns.id === this.order.namespace)?.name;
      // } else {
      //   this.namespaceName = undefined;
      // }
      //

      if (appState.order?.user_cfg?.when_tag) {
        const w = MenuUtils.readableWhen(appState.order?.user_cfg?.when_tag);
        if (w) {
          this.whenReadable = `Serveras ${w}`;
        } else {
          this.whenReadable = undefined;
        }
      }

      // if (appState.order.user_cfg.is_anon && appState.order.user_cfg.email != null) {
      //   this.emailFormControl.setValue(appState.order.user_cfg.email);
      //   this.anonPanelOpen = true;
      // }
      //

      this.customCollects = [];
      if (appState.order.user_cfg.collect?.phone) {
        const validators = [Validators.required, this.phoneNumberValidator.bind(this)];
        const p = appState.order.user_cfg.phone;
        const v = this.getCustomCollectValue("__phone", p);
        const fc = new FormControl(v, validators);
        this.customCollects.push({ id: "__phone", title: this.getString("Telefon"), inputType: "phone", placeholder: "0767-123456", value: v, formControl: fc});
      }

      if (appState.order.user_cfg.collect?.custom != null) {
        for (const cc of appState.order.user_cfg.collect.custom) {
          const inputType = cc.type ?? "text";
          const validatorOrOpts = cc.required ? [Validators.required] : [];
          // Typed-but-unsynced values live in localStorage (customChanged) until
          // nextPage() sends them; restore them here so the app-state rebuild after
          // additem/removeitem or a navigation doesn't wipe the field. `value` stays
          // the server value so hasChanged still triggers the sync.
          const v = this.getCustomCollectValue(cc.id, cc.value);
          const fc = new FormControl(v, validatorOrOpts);
          this.customCollects.push({ id: cc.id, title: cc.title, description: cc.description, inputType, placeholder: cc.placeholder, value: cc.value, formControl: fc});
        }
      }

      const tipConfig = this.tipService.getTip(appState, this.order.items, 'closed', false);
      if (tipConfig) {
        this.tipConfig = tipConfig;
      } else {
        // Old behavior without tip config
        this.tipConfig = this.tipService.getTipConfigWhenMissingConfig(false, this.order?.user_cfg?.payment?.use_tip);
      }
      this.showTip = this.tipConfig.tipActive;
      this.tipAmount = this.tipConfig.defaultTip;
      this.tipButtonId = this.tipConfig.defaultButtonId;

      console.log("Tip config:", this.tipConfig);

      // Is this a dual page, e.g. takeaway or does it have some custom collects?
      if (this.isDualPage == null) {
        this.showMainContent = true;
        this.showOrderPayTip = true;
        this.isDualPage = this.customCollects.length>0 || appState.order?.user_cfg?.dt === 'takeaway' || appState.order?.user_cfg?.collect?.fulfillment;
        if (this.isOpenPrebook()) {
          // Open prebooking books directly without payment or tip, so the second
          // page would only duplicate the "Konfirmera bokning" button. Single page
          // unless there are custom collects to fill in first.
          this.isDualPage = this.customCollects.length > 0;
        }
        if (this.isDualPage) {
          this.showOrderPayTip = false;
        }
      }

    });

    // this.sub2 = this.translate.translationsReceivedSubject.subscribe(() => {
    //   console.log("Retranslate order after translations received");
    //   this.translate.order(this.order);
    // });
  }

  private setupItemsForDisplay() {
    this.editableItems = [];
    this.fixedItems = [];
    this.includedChildrenByRid = {};
    this.packageDetailsByRid = {};
    this.packageChangeableByRid = {};
    // Drop package component rows, keep the package placeholder
    const filteredItems = this.order!.items.filter(item => item.package == null || item.package.aggregated_cent != null);
    const menuStruct = this.menu.getMenuStructure();
    for (const item of filteredItems) {
      if (item.package) {
        this.packageDetailsByRid[item.rid] = MenuUtils.packageDetailLines(item, this.order!.items, menuStruct);
        if (menuStruct) {
          const lookup = (id: string) => MenuUtils.getItemInMenu(id, menuStruct);
          this.packageChangeableByRid[item.rid] = MenuUtils.isPackageChangeable(lookup(item.package.id ?? item.item), lookup);
        }
      }
    }

    // Nest only included/mandatory children. Plain push children stay editable.
    for (const item of filteredItems) {
      const isFixedChild = item.parent_rid && (item.included === true || item.mandatory === true);
      if (isFixedChild) {
        (this.includedChildrenByRid[item.parent_rid!] ??= []).push(item);
      } else if (item.fixed) {
        this.fixedItems.push(item);
      } else {
        this.editableItems.push(item);
      }
    }
  }


  handleNextAction() {

  }

  back() {
    if (this.isDualPage && this.showOrderPayTip) {
      this.showMainContent = true;
      this.showOrderPayTip = false;
      return
    } else {
      this.identityService.navigateBack();
    }
  }

  navSignin() {
    this.router.navigate([this.appStateService.venueId, "signin"], {skipLocationChange: true});
  }

  getString(s: string) {
    return this.translate.getString(s);
  }

  translateItemComment(comment: string): string {
    return this.translate.translateItemComment(comment);
  }

  public getPrice(item: any): number {
    if(item.package && item.package.aggregated_cent != null) {
      return item.package.aggregated_cent / 100;
    }
    return item.price;
  }

  hasItems() {
    if (!this.order?.current) {
      return null;
    }
    // The booker of a shared prebooking sends the party's order, with or without dishes of their own
    return this.order?.items.length > 0 || (this.order?.prebook?.role === 'booker' && this.partyOthers().some(guest => guest.items.length > 0));
  }

  onChangeAmount(item: OrderItem, amount: number) {
    if (this.isWorking) return;
    item.count += amount;
    if (amount > 0) {
      this.addCopy(item);
    } else {
      this.subtractCopy(item);
    }
  }

  addCopy(orderItem: OrderItem) {
    this.isWorking = true;
    const uid = Math.random().toString(36).substring(7);
    this.orderService.addItemToOrder(orderItem.id, undefined, uid, undefined, orderItem.rid).subscribe((order: Order) => {
      },
      undefined,
      () => {
        this.isWorking = false;
      }
    );
  }

  subtractCopy(orderItem: OrderItem) {
    this.isWorking = true;
    console.log(`onSub: ${orderItem.id} ${orderItem.package != null}`);
    this.orderService.removeItemFromOrder(orderItem.id, orderItem.package != null).subscribe({
      next: (order: Order) => {
        if (MenuUtils.getItemCount(order.items) === 0) {
          this.back();
        }
      },
      error: undefined,
      complete: () => {
        this.isWorking = false;
      }
    });
  }

  showDiscountDialog() {
    const dialogRef = this.modalService.show(EnterDiscountCodeDialogComponent, {
      data: {},
      closeOnBackdrop: false,
    });
  }

  isDTOpen(): boolean {
    if (!this.order || !this.appState) {
      return false;
    }
    return MenuUtils.isDeliverTypeOpen(this.order.user_cfg.dt, this.appState.cfg);
  }

  mustScan(): boolean {
    if (this.auth.kioskMode) { return false; }
    if (this.appState?.order.user_cfg.table?.startsWith("SNOTA_")) {
      return true;
    }
    return this.appState?.order.user_cfg.must_scan ?? true;
  }

  canOrder(): boolean {
    return this.auth.kioskMode || (this.order?.user_cfg.payment?.can_order ?? false);
  }

  isFree() {
    return this.order!.amount === 0;
  }

  verify() {
    this.bottomSheetService.displaySignin(1);
  }

  send() {
    if (this.appState!.order.user_cfg.must_rescan && !this.isKiosk) {
      this.openRescanDialog( confirmed => {
        if (confirmed) {
          this.send();
        }
      });
      return;
    }

    if (this.showSpinner) {
      return;
    }
    this.showSpinner = true;
    this.addInlinePushToOrder().pipe(
      mergeMap(res => this.orderService.placeOrder())
    ).subscribe({
      next: res => {
        //this.messengerService.doPostAction(this.venueId, "order_sent");
        this.handlePostOrder();
      },
      complete: () => { this.showSpinner = false; }
    });
  }

  openRescanDialog(after: (confirmed: boolean) => void) {
    const dialogRef = this.modalService.show(RescanDialogComponent, {
      data: {
        title: this.getString("Bekräfta din plats"),
        message: (this.getString("Är du kvar på") + " " + this.order?.user_cfg.table + "?"),
        buttons: [
          { action:'confirm', text: this.getString("Ja") },
          { action:'changeTable', text: this.getString("Byt bord") },
        ]
      }
    });

    dialogRef.subscribe((result: any) => {
      after(result);
    });
  }

  selectedChange(selectedItem: MenuItem) {
    // A package that asks something is ticked once its options are picked in the item view
    const menuStruct = this.menu.getMenuStructure();
    if (this.selectedItems[selectedItem.id] && menuStruct &&
        MenuUtils.isPackageChangeable(selectedItem, id => MenuUtils.getItemInMenu(id, menuStruct))) {
      this.selectedItems[selectedItem.id] = false;
      this.openPicks(selectedItem);
      return;
    }
    // Setup default attribute values
    this.attrValues[selectedItem.id] = {};
    for (const atr of selectedItem.attributes ?? []) {
      if (!atr.hidden && !this.attrValues[selectedItem.id][atr.id]) {
        const opt = atr.options.find(o => o.default) ?? (atr.options.length > 1 ? atr.options[0] : undefined);
        if (opt) {
          this.attrValues[selectedItem.id][atr.id] = opt.key;
        }
      }
    }
  }

  openPicks(item: MenuItem) {
    this.bottomSheetService.displayPackagePick(item, {
      startId: this.picked[item.id]?.id,
      done: picked => {
        this.picked[item.id] = picked;
        this.selectedItems[item.id] = true;
      }
    });
  }

  private prepareInlinePush(menuStruct: MenuStructure) {
    const pushIds = new Set();
    const itemIds = new Set();
    for (const item of this.order!.items) {
      const itemId = item.item;
      itemIds.add(itemId);
      if (!itemId.startsWith("iddrk")) { continue; }
      const mit = MenuUtils.getItemInMenu(itemId, menuStruct);
      for (const mipush of mit?.pushes ?? []) {
        for (const pgroup of mipush.groups) {
          for (const pushId of pgroup.items) {
            if (!this.menu.isOutOfStock(pushId)) {
              pushIds.add(pushId);
            }
          }
        }
      }
    }

    //No inline push when ordering food
    for (const itemId of itemIds) {
      // @ts-ignore
      if (itemId.startsWith("idfd")) {
        pushIds.clear();
      }
    }

    const recList = [];
    for (const pushId of pushIds) {
      if (itemIds.has(pushId)) { continue; }
      // @ts-ignore
      const mi = MenuUtils.getItemInMenu(pushId, menuStruct);
      if (mi) {
        recList.push(mi);
      }
    }

    this.selectedItems = {};
    this.picked = {};
    this.inlineRecommendations = recList.length > 0 ? recList : null;
    console.log("Inline push:", this.inlineRecommendations);

    // Donations
    if (menuStruct.donation_items?.length > 0) {
      const donationIds = menuStruct.donation_items.map(d => d.id);
      let includesDonation = false;
      for (const item of this.appState!.order.items) {
        const itemId = item.item;
        if (donationIds.includes(itemId)) {
          //Already includes a donation
          includesDonation = true;
        }
      }
      this.inlineDonations = !includesDonation ? menuStruct.donation_items : undefined;
    }

  }

  private extractPostactionInfo(menuStructure: MenuStructure) {
    for (const item of this.order!.items) {
      const mit = MenuUtils.getItemInMenu(item.item, menuStructure);
      item.has_post_actions = mit.post_actions != null && mit.post_actions.length > 0;
    }
  }

  addInlinePushToOrder(): Observable<any> {
    const menuStruct = this.menu.getMenuStructure();
    const itemIds = MenuUtils.collectSelectedItemIds(this.selectedItems, this.attrValues, menuStruct, this.picked);
    if (itemIds.length > 0) {
      console.log("addInlinePushToOrder...");
      this.showSpinner = true;
      return this.orderService.addItemsToOrder(itemIds, undefined, false, false).pipe(
        tap(r => { this.showSpinner = false; })
      );
    } else {
      return of({});
    }
  }

  private buildPayableRefs() {
    if (this.itemRefs && this.itemRefs.length>0) {
      return this.itemRefs.join(",");
    }
    return undefined;
  }

  async pay(method: string) {
    if (method === "card") {
      method = await SelectCardDialogComponent.showSelectCardDialog(this.modalService, this.appState!);
    } else if (method === "prepaid") {
      if (this.appState!.order!.user_cfg.payment!.prepaid_balance < this.appState!.order.total_pre!) {
        this.bottomSheetService.displaySheetClass("prepaid-card", this.getString("Fyll på saldo"));
        return;
      }
    }

    try {
      await firstValueFrom(this.addInlinePushToOrder());
    } catch (error) {
      this.snackbarService.showMessageForError(error);
      return;
    }

    this.showSpinner = true;
    const payableRefs = this.buildPayableRefs();
    const pid: PaymentInputData = {
      tipParam: "v"+this.tipAmount,
      method: method,
      payableRefs: payableRefs,
      declineRoute: "cart/paymentfailed",
    };
    this.showSpinner = true;
    try {
      const pod = await this.paymentService.pay(pid);
      this.handlePostPayment(pod);
    } catch (error) {
      this.snackbarService.showMessageForError(error);
    } finally {
      this.showSpinner = false;
    }
  }

  payableOrOrderable() {
    return this.appState && this.order && this.isDTOpen() && this.hasItems() && this.canOrder() && !this.mustScan()
  }

  isPrebookMode(): boolean {
    return this.order?.prebook?.can_edit ?? false;
  }

  // Prebook is either/or by template, carried by the server in payment.open_order:
  // open tab (open_order) books without payment and pays at the venue ("Konfirmera
  // bokning", single page, books directly), closed tab must be paid online ("Betala
  // och boka"). The server enforces both directions; the button texts and the
  // single-page mode are the only prebook-specific parts here.
  isOpenPrebook(): boolean {
    return this.isPrebookMode() && (this.order?.user_cfg?.payment?.open_order ?? false);
  }

  // Open prebook: confirming locks the booking, so the guest is told right above the
  // button that editing is possible until then and what the deadline is
  confirmInfoText(): string {
    const editLockAt = this.order?.prebook?.edit_lock_at;
    let text = editLockAt ? this.getString('Konfirmera senast') + ' ' + TimeUtils.formatDeadlineClock(editLockAt) + '. ' : '';
    text += this.getString(this.partyOthers().length
      ? 'Då skickas hela sällskapets beställning till restaurangen och kan inte ändras längre.'
      : 'Då skickas din beställning till restaurangen och kan inte ändras längre.');
    return text + ' ' + this.getString('Fram till dess kan du ändra den via länken i din bokningsbekräftelse.');
  }

  // The booker of a shared prebooking: only they know who of the party orders, and someone may order for several,
  // so the page never says the party is complete. It names who has opened the link without choosing yet
  partyStatusText(): string {
    if (!this.partyOthers().length) {
      return '';
    }
    const notDone = this.partyOthers().filter(guest => !guest.done).map(guest => guest.name);
    const names = notDone.length === 1 ? notDone[0] : notDone.slice(0, -1).join(', ') + ' ' + this.getString('och') + ' ' + notDone[notDone.length - 1];
    return (notDone.length ? names + ' ' + this.getString('har inte valt klart än.') + ' ' : '') +
      this.getString('Kolla att alla i sällskapet har fått med sin mat. Du kan själv lägga till åt den som inte har beställt.');
  }


  isParticipant(): boolean {
    return this.isPrebookMode() && this.order?.prebook?.role === 'participant';
  }

  // The rest of a shared prebooking's party, with what each has picked
  partyOthers(): PrebookPartyGuest[] {
    return this.order?.prebook?.party?.filter(guest => !guest.is_me) ?? [];
  }

  myPartDone(): boolean {
    return this.order?.prebook?.party?.find(guest => guest.is_me)?.done ?? false;
  }

  // A participant's part is locked once they're done, until they change it again
  partLocked(): boolean {
    return this.isParticipant() && this.myPartDone();
  }

  participantInfoText(): string {
    const booker = this.order?.prebook?.party?.find(guest => guest.is_booker)?.name ?? this.getString('Den som bokade');
    if (this.myPartDone()) {
      return booker + ' ' + this.getString('skickar in beställningen för hela sällskapet.');
    }
    return this.getString('När du har valt klart skickar') + ' ' + booker + ' ' + this.getString('in beställningen för hela sällskapet.');
  }

  markPartDone() {
    this.isWorking = true;
    this.orderService.prebookParticipantDone().subscribe({
      next: () => this.isWorking = false,
      error: (e) => {
        console.error("prebook_participant_done failed", e);
        this.isWorking = false;
        this.snackbarService.showMessageForError(e);
      }
    });
  }

  reopenPart() {
    this.isWorking = true;
    this.orderService.prebookParticipantReopen().subscribe({
      next: () => this.isWorking = false,
      error: (e) => {
        console.error("prebook_participant_reopen failed", e);
        this.isWorking = false;
        this.snackbarService.showMessageForError(e);
      }
    });
  }

  primaryPageActionText(): string {
    if (!this.isPrebookMode()) {
      return this.getString('Betala');
    }
    // Open prebook only reaches page 1 when custom collects force a dual page;
    // "Konfirmera bokning" is reserved for the button that actually books (send)
    return this.getString(this.isOpenPrebook() ? 'Fortsätt' : 'Betala och boka');
  }

  private handlePostOrder() {
    this.router.navigate([this.appStateService.venueId, 'feed']);
  }

  get payableRefsForDirect(): string | undefined {
    return this.buildPayableRefs();
  }

  handleDirectPaymentComplete(event: { receiptKey: string }) {
    this.router.navigate([this.appStateService.venueId, 'paystatus', event.receiptKey]);
  }

  handleDirectPaymentFailed(error: any) {
    console.warn('Direct wallet payment failed', error);
    this.snackbarService.showMessageForError(error);
  }

  private handlePostPayment(pod: PaymentOutputData) {
    console.log('Payment result:', pod);

    // Check if this is an error response (navUrl points to decline route and has error)
    if (pod.navUrl && pod.navUrl.includes('paymentfailed') && pod.methodResponse?.error) {
      // Show the actual error message instead of redirecting
      this.snackbarService.showMessageForError({ error: { message: pod.methodResponse.error } });
      return;
    }

    if (pod.navUrl) {
      //const decodedNavUrl = decodeURIComponent(pod.navUrl);
      this.router.navigateByUrl(pod.navUrl);
    } else if (pod.checkPayStatusReceiptKey) {
      this.router.navigate([this.appStateService.venueId, 'paystatus', pod.checkPayStatusReceiptKey]);
    } else {
      this.router.navigate([this.appStateService.venueId, 'feed']);
    }
  }

  openWebcodeDialog() {
    this.modalService.show(WebCodeModalComponent, {
      data: {}
    });
  }

  openRoomCodeDialog() {
    this.modalService.show(RoomCodeModalComponent, {
      data: {}
    });
  }

  handleTipChange($event: TipChangeEvent) {
    this.tipAmount = $event.amount;
    this.updateTitle();
  }

  private updateTitle() {
    const totalIncludingTip = this.order!.amount + (this.tipAmount??0);
    this.actionTitle = `Betala ${MoneyUtils.formatNoCents(totalIncludingTip)}`;
  }

  nextPage() {
    if (this.appState?.order?.user_cfg?.collect?.fulfillment && !this.fulfillmentMode) {
      this.snackbarService.showMessage(this.getString("Vänligen välj äta här eller ta med innan du går vidare."));
      return;
    }

    if (!this.pickupLocation && this.appState?.order?.user_cfg?.collect?.pickup_locations &&
      this.appState.order.user_cfg.collect.pickup_locations.length > 0) {
        this.snackbarService.showMessage(this.getString("Vänligen välj en upphämtningsplats innan du går vidare."));
        return;
    }

    if (this.customCollects) {
      const missing = this.checkMissingCustomCollects();
      if (missing.length > 0) {
        const alertMessage = this.customCollects
          .filter(collect => collect.formControl.errors !== null)
          .map(collect => {
            if (!collect.formControl.value) {
              return `Vänligen fyll i "${collect.title}"`;
            }
            return `"${collect.title}" ej giltigt vänligen kontrollera`;
          })
          .join('\n');
        this.snackbarService.showMessage(alertMessage);
        return;
      }

      console.log(this.customCollects);

      // Always sync a pre-filled phone to the server, even if the field wasn't edited.
      // It's pre-filled from the account/localStorage but may not yet be stored on the
      // chat — skipping the send there silently drops the pickup-ready SMS (cold food).
      const phone = this.customCollects.find(cc => cc.id === "__phone")?.formControl.value;
      const hasChanged = this.customCollects.some(cc => cc.formControl.value !== cc.value);
      if (phone || hasChanged) {
        this.isWorking = true;
        const customValues = this.customCollects
          .filter(cc => !cc.id.startsWith("__"))
          .reduce((acc, cc) => ({...acc, [cc.id]: cc.formControl.value}), {});
        this.orderService.updateCollected(phone, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, customValues).subscribe({
          next: res => {
            console.log("Updated custom collect:", res);
            this.changePage();
            this.isWorking = false;
          },
          error: () => {
            this.isWorking = false;
          }
        });
        return;
      }
    }

    this.changePage();
  }

  private changePage() {
    this.resetLocalCustomCollects();
    if (this.appState?.order.user_cfg.collect?.slot_time && this.appState?.order.pickup_date == null) {
      this.bottomSheetService.displaySheetClass("select-date_time", this.getString("Välj tid och datum"));
      return;
    }

    this.showMainContent = false;
    this.showOrderPayTip = true;
  }

  checkMissingCustomCollects(): string[] {
    return this.customCollects!
      .filter(collect => collect.formControl.errors !== null)
      .map(collect => collect.title);
  }

  selectSlotTime() {
    this.bottomSheetService.displaySheetClass("select-date_time", this.getString("Välj tid och datum"));
  }

  getTakeawayButtonText() {
    if (this.pickupDateText) {
      const verb = this.order?.user_cfg?.delivery_model === 'delivery' ? this.getString("Levereras"):this.getString("Hämtas");
      return verb + " " + this.pickupDateText;
    } else {
      return this.order?.user_cfg?.delivery_model === 'delivery' ? this.getString("Välj leveransstid"):this.getString("Välj upphämtningstid");
    }
  }

  changePickupLocation(pl: string) {
    this.showSpinner = true;
    this.orderService.updateCollected(undefined, undefined, pl, undefined).subscribe(res => {
      this.showSpinner = false;
    });
  }

  changeFulfillmentMode(mode: string) {
    this.showSpinner = true;
    this.orderService.updateCollected(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, mode).subscribe(res => {
      this.showSpinner = false;
    });
  }

  displayItem(orderItem: OrderItem) {
    // A package with choices shows nothing to read without them: open it to change its picks
    if (this.packageChangeableByRid[orderItem.rid] && !this.partLocked()) {
      this.changePackage(orderItem);
      return;
    }
    this.menu.getItem(orderItem.item, this.appState!.venueId.toString()).subscribe(item => {
      const outOfStock = this.menu.isOutOfStock(item!.id);
      const venueOpen = this.isDTOpen();
      this.bottomSheetService.displayItem(item!, "display");
    });
  }

  // Change the picks of a package in the cart: the item sheet opens with them selected
  changePackage(orderItem: OrderItem) {
    if (this.isWorking || this.partLocked()) return;
    this.menu.getItem(orderItem.item, this.appState!.venueId.toString()).subscribe(item => {
      if (item) {
        this.bottomSheetService.displayItem(item, "edit", orderItem);
      }
    });
  }

  phoneNumberValidator(control: AbstractControl): ValidationErrors | null {
    console.log("Phone number validator", control.value);
    if (!control.value) return null;
    const v = control.value.replace(/[- +()]/g, '');
    return /^[0-9]{9,14}$/.test(v) ? null : { phoneNumberInvalid: true };
  }

  customChanged(cc: any) {
    //cc example { id: "__phone", title: "Telefon", inputType: "phone", placeholder: "0767-123456", value: p, formControl: fc}
    const newValue = cc.formControl.value;
    const hasChanged = newValue !== cc.value;
    console.log(cc.id, cc.formControl.value, cc.value, hasChanged);
    if (!hasChanged) return;
    const uniqueId = `${this.appState?.venueId!}-${cc.id}`;
    localStorage.setItem(uniqueId, cc.formControl.value);
  }

  getInputType(it: any): string {
    switch (it) {
      case "phone":
        return "tel";
      default:
        return it;
    }
  }

  private getCustomCollectValue(id: string, value: string | undefined) {
    const uniqueId = `${this.appState?.venueId!}-${id}`;
    const lsv = localStorage.getItem(uniqueId);
    console.log(`getCustomCollectValue ${uniqueId}, ${lsv}`);
    if (lsv != null) {
      return lsv;
    }
    return value;
  }

  private resetLocalCustomCollects() {
    for (const cc of this.customCollects!) {
      const uniqueId = `${this.appState?.venueId!}-${cc.id}`;
      localStorage.removeItem(uniqueId);
    }
  }

  timeClassChanged(tc: string) {
    if (tc === "later") {
      this.openSelectTimeDialog();
    } else if (tc === "now") {
      this.showSpinner = true;
      this.orderService.updateCollected(undefined, 0, undefined, undefined).subscribe(res => {
        this.showSpinner = false;
      });
    }
    return false;
  }

  openSelectTimeDialog() {
    this.modalService.show(SelectTimeDialogComponent, {
      data: {}
    });
  }

  activateDiscount(code: UserSpecificConfigLoyaltyDiscountCode) {
    this.isLoading = true;
    this.orderService.addDiscountCode(code.code).subscribe(
      (r) => {
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
        console.log("Error", err);
      }
    );
  }

  activateReward(rewardTrigger: UserSpecificConfigLoyaltyRewardTrigger) {
    this.orderService.activateReward(this.loyaltyInfo!.key!, rewardTrigger.id).subscribe(
      (r) => {
      },
      (err) => {
        console.log("Error", err);
      }
    );
  }

  terms() {
    this.router.navigateByUrl(`${this.appStateService.venueId}/terms`);
    return false;
  }
}
